<script lang="ts" setup>
import { computed } from "vue"
import { Multiselect as VueMultiselect } from "vue-multiselect"

const props = defineProps<{
    context?: any
}>()

const options = computed(() => {
    const options = props.context.optionsFiltered || props.context.options || []
    return options.map((option: { label: string; value: string }) => ({
        name: option.label,
        value: option.value,
    }))
})

const model = computed({
    get: () => {
        return {
            name: getOptionName(props.context.value),
            value: props.context._value,
        }
    },
    set: value => {
        props.context.node.input(value.value)
    },
})

function getOptionName(id: string): string | undefined {
    return options.value.find((option: { name: string; value: string }) => option.value === id)?.name
}
</script>
<template>
    <VueMultiselect
        v-model="model"
        :options="options"
        :placeholder="context.node.context.label"
        label="name"
        track-by="value"
        :multiple="false"
    ></VueMultiselect>
</template>
